import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "home-body"
};
var _hoisted_2 = {
  class: "main-list"
};
var _hoisted_3 = {
  class: "list-body"
};
var _hoisted_4 = {
  class: "base-list"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "base-list"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  class: "base-list"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "list-footer"
};
var _hoisted_11 = ["src"];
var _hoisted_12 = {
  class: "visitors-list"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  key: 0,
  class: "visitor_left"
};
var _hoisted_15 = ["src"];
var _hoisted_16 = {
  class: "left_name"
};
var _hoisted_17 = {
  class: "student_name"
};
var _hoisted_18 = {
  class: "school_name"
};
var _hoisted_19 = ["src"];
var _hoisted_20 = {
  key: 2,
  class: "visitor_right"
};
var _hoisted_21 = {
  key: 3,
  class: "base_name"
};
var _hoisted_22 = {
  class: "lately-visitor"
};
var _hoisted_23 = {
  key: 0,
  class: "lately_list"
};
var _hoisted_24 = {
  class: "user"
};
var _hoisted_25 = {
  class: "user_left"
};
var _hoisted_26 = ["src"];
var _hoisted_27 = {
  class: "name"
};
var _hoisted_28 = {
  class: "user_time"
};
var _hoisted_29 = {
  key: 1,
  class: "no_content"
};
import { MessagePlugin } from 'tdesign-vue-next';
import { formatRelativeDate } from '@/util/date';
import { computed, ref, watch, onMounted } from 'vue';
import BaseList from './BaseList.vue';
import CreateItem from '../components/createItem.vue';
import AlbumItem from '../components/albumItem.vue';
import ActivityItem from '../components/activityItem.vue';
import { useRouter } from 'vue-router';
import { throttle } from '@/util/util.js';
import calling from './calling.vue';
import { Spatial, guestList, create, photos, events, casual } from '@/api/personalHomepage';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  props: {
    clickRightValue: {
      type: Number,
      default: 0
    },
    clickLeftValue: {
      // 展示范围
      type: String,
      default: ''
    },
    IdPeople: {
      type: String,
      default: ''
    },
    namePeople: {
      type: String,
      default: ''
    },
    // without: { //是否是外部跳进来的
    //   type: Boolean,
    //   default: false
    // }
    spaceInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['changeId'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var props = __props;
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取userInfo
    var router = useRouter();
    var visListShow = computed(function () {
      return props.clickRightValue;
    });
    // 进入图片
    var rightEnter = require('@/assets/home/rightEnter.svg');
    var rightGray = require('@/assets/home/double.svg');
    var baseImg = require('@/assets/home/baseImg.svg');

    // 创作数
    var creationData = ref([]);
    // 相册数据
    var photoData = ref([]);
    // 活动数据
    var activityData = ref([]);

    // 搜索数据
    var searchIdName = ref('');
    var showMe = ref(false);
    var clickSerch = ref(false);
    var peopleList = ref({}); // 搜索时展现的数据
    // 搜索
    var handleSearch = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$Spatial, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(searchIdName.value === '')) {
                _context.n = 1;
                break;
              }
              return _context.a(2, MessagePlugin.error('请输入主页ID,不能为空'));
            case 1:
              clickSerch.value = true;
              _context.p = 2;
              _context.n = 3;
              return Spatial(searchIdName.value);
            case 3:
              _yield$Spatial = _context.v;
              data = _yield$Spatial.data;
              peopleList.value = data.data;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              MessagePlugin.error('请求失败，请重试');
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[2, 4]]);
      }));
      return function handleSearch() {
        return _ref2.apply(this, arguments);
      };
    }();
    // 监听搜索页面的弹出
    watch(function () {
      return searchIdName.value;
    }, function (val) {
      if (val !== '') {
        showMe.value = true;
      } else {
        showMe.value = false;
        clickSerch.value = false;
      }
    }, {
      deep: true,
      immediate: true
    });
    var visList = ref([]); // 最近访客
    // 访客列表
    var getUserInfoList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        var _yield$guestList, data, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return guestList(id);
            case 1:
              _yield$guestList = _context2.v;
              data = _yield$guestList.data;
              visList.value = data.data;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              MessagePlugin.error('请求失败，请重试');
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function getUserInfoList(_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    // 列表详情
    var cardInfo = ref(0);
    var handleVisibleChange = function handleVisibleChange(index) {
      cardInfo.value = index;
    };

    // 创作接口数据
    var getCreationData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(id) {
        var query, _yield$create, data, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              query = {
                size: 9,
                current: 1,
                userId: id,
                viewRadius: props.clickLeftValue,
                userName: props.namePeople,
                spaceHideFlag: props.clickRightValue === 1 ? null : 0
              };
              _context3.p = 1;
              _context3.n = 2;
              return create(query);
            case 2:
              _yield$create = _context3.v;
              data = _yield$create.data;
              creationData.value = data.data.records;
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 3]]);
      }));
      return function getCreationData(_x2) {
        return _ref4.apply(this, arguments);
      };
    }();

    // 相册接口数据
    var getPhotoData = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(id) {
        var query, _yield$photos, data, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              query = {
                size: 9,
                current: 1,
                userId: id,
                viewRadius: props.clickLeftValue,
                spaceHideFlag: props.clickRightValue === 1 ? null : 0
              };
              _context4.p = 1;
              _context4.n = 2;
              return photos(query);
            case 2:
              _yield$photos = _context4.v;
              data = _yield$photos.data;
              photoData.value = data.data.records;
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 3]]);
      }));
      return function getPhotoData(_x3) {
        return _ref5.apply(this, arguments);
      };
    }();

    // 活动接口数据
    var getActivityData = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id) {
        var query, _yield$events, data, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              query = {
                size: 9,
                current: 1,
                userId: id,
                viewRadius: props.clickLeftValue,
                spaceHideFlag: props.clickRightValue === 1 ? null : 0
              };
              _context5.p = 1;
              _context5.n = 2;
              return events(query);
            case 2:
              _yield$events = _context5.v;
              data = _yield$events.data;
              activityData.value = data.data.records;
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t5 = _context5.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context5.a(2);
          }
        }, _callee5, null, [[1, 3]]);
      }));
      return function getActivityData(_x4) {
        return _ref6.apply(this, arguments);
      };
    }();

    // 点赞刷星
    var likeStar = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(val) {
        var id;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              id = props.IdPeople;
              if (!(val === 'album')) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return getPhotoData(id);
            case 1:
              _context6.n = 5;
              break;
            case 2:
              if (!(val === 'create')) {
                _context6.n = 4;
                break;
              }
              _context6.n = 3;
              return getCreationData(id);
            case 3:
              _context6.n = 5;
              break;
            case 4:
              if (!(val === 'active')) {
                _context6.n = 5;
                break;
              }
              _context6.n = 5;
              return getActivityData(id);
            case 5:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function likeStar(_x5) {
        return _ref7.apply(this, arguments);
      };
    }();
    // 随便逛逛
    var handleRandom = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _userInfo$memberType;
        var query, _yield$casual, data, _t6;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              query = {
                platform: (_userInfo$memberType = userInfo.memberType) !== null && _userInfo$memberType !== void 0 && _userInfo$memberType.some(function (role) {
                  return role === 'teacher';
                }) ? 0 : 1,
                currentHomeUserId: props.spaceInfo.id
              };
              _context7.p = 1;
              _context7.n = 2;
              return casual(query);
            case 2:
              _yield$casual = _context7.v;
              data = _yield$casual.data;
              if (data.data) {
                emit('changeId', data.data.userId, 0, data.data.userType);
              } else {
                MessagePlugin.warning('暂无可随便逛逛主页');
              }
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t6 = _context7.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context7.a(2);
          }
        }, _callee7, null, [[1, 3]]);
      }));
      return function handleRandom() {
        return _ref8.apply(this, arguments);
      };
    }();
    var handleClick = throttle(function () {
      handleRandom();
    }, 1000);
    // 跳转接口
    var navigateTo = function navigateTo(item) {
      // 0 创作 1 相册 2 活动
      if (item === 0) {
        router.push('/inspirationCentre?inspirationCentre=%2Fcourse');
      } else if (item === 1) {
        router.push('/classPhoto');
      } else if (item === 2) {
        router.push('/activity');
      }
    };
    // 点击进入主页
    var backHomeMe = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(val) {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              showMe.value = false;
              emit('changeId', val.userId, 0, val.userType);
            case 1:
              return _context8.a(2);
          }
        }, _callee8);
      }));
      return function backHomeMe(_x6) {
        return _ref9.apply(this, arguments);
      };
    }();
    var changeToHome = function changeToHome(val, userType) {
      emit('changeId', val, 0, userType);
      // console.log('第二');
    };
    // 初始化数据
    var initData = /*#__PURE__*/function () {
      var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(id) {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return getCreationData(id);
            case 1:
              _context9.n = 2;
              return getPhotoData(id);
            case 2:
              _context9.n = 3;
              return getActivityData(id);
            case 3:
              _context9.n = 4;
              return getUserInfoList(id);
            case 4:
              return _context9.a(2);
          }
        }, _callee9);
      }));
      return function initData(_x7) {
        return _ref0.apply(this, arguments);
      };
    }();
    watch(function () {
      return props;
    }, function (val) {
      var clickLeftValue = val.clickLeftValue,
        IdPeople = val.IdPeople;
      if (IdPeople) {
        initData(IdPeople, clickLeftValue);
      }
    }, {
      deep: true,
      immediate: true
    });

    // 切换导航事件
    var navChangeEvent = function navChangeEvent(index) {
      emit('changeNav', index);
    };
    return function (_ctx, _cache) {
      var _component_t_input = _resolveComponent("t-input");
      var _component_t_popup = _resolveComponent("t-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(BaseList, {
        title: "我的创作",
        tip: "展示自己申请入库且审核通过的学程",
        empty: creationData.value.length === 0,
        onChange: _cache[1] || (_cache[1] = function ($event) {
          return navChangeEvent(1);
        })
      }, _createSlots({
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(creationData.value, function (item, index) {
            return _openBlock(), _createBlock(CreateItem, {
              key: index,
              data: item,
              clickRightValue: __props.clickRightValue,
              onLike: likeStar
            }, null, 8, ["data", "clickRightValue"]);
          }), 128))])];
        }),
        _: 2
      }, [__props.clickRightValue == 1 ? {
        name: "empty-footer",
        fn: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "empty-footer",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return navigateTo(0);
            })
          }, [_cache[9] || (_cache[9] = _createTextVNode(" 点击前往- ", -1)), _cache[10] || (_cache[10] = _createElementVNode("span", {
            class: "tip"
          }, "创作中心", -1)), _cache[11] || (_cache[11] = _createTextVNode("-创作 ", -1)), _createElementVNode("img", {
            class: "right_icon",
            src: _unref(rightGray),
            alt: ""
          }, null, 8, _hoisted_5)])];
        }),
        key: "0"
      } : undefined]), 1032, ["empty"]), _createVNode(BaseList, {
        title: "我的相册",
        tip: "展示自己上传至班级相册的内容",
        empty: photoData.value.length === 0,
        onChange: _cache[3] || (_cache[3] = function ($event) {
          return navChangeEvent(2);
        })
      }, _createSlots({
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photoData.value, function (item, index) {
            return _openBlock(), _createBlock(AlbumItem, {
              key: index,
              data: item,
              "Id-people": __props.IdPeople,
              "click-left-value": __props.clickLeftValue,
              clickRightValue: __props.clickRightValue,
              onLike: likeStar
            }, null, 8, ["data", "Id-people", "click-left-value", "clickRightValue"]);
          }), 128))])];
        }),
        _: 2
      }, [__props.clickRightValue == 1 ? {
        name: "empty-footer",
        fn: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "empty-footer",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return navigateTo(1);
            })
          }, [_cache[12] || (_cache[12] = _createTextVNode(" 点击前往- ", -1)), _cache[13] || (_cache[13] = _createElementVNode("span", {
            class: "tip"
          }, "班级相册", -1)), _createElementVNode("img", {
            class: "right_icon",
            src: _unref(rightGray),
            alt: ""
          }, null, 8, _hoisted_7)])];
        }),
        key: "0"
      } : undefined]), 1032, ["empty"]), _createVNode(BaseList, {
        title: "我的活动",
        tip: "展示已参加的活动，不包含已下架活动",
        empty: activityData.value.length === 0,
        onChange: _cache[5] || (_cache[5] = function ($event) {
          return navChangeEvent(3);
        })
      }, _createSlots({
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.value, function (item, index) {
            return _openBlock(), _createBlock(ActivityItem, {
              key: index,
              data: item,
              clickRightValue: __props.clickRightValue,
              onLike: likeStar
            }, null, 8, ["data", "clickRightValue"]);
          }), 128))])];
        }),
        _: 2
      }, [__props.clickRightValue == 1 ? {
        name: "empty-footer",
        fn: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "empty-footer",
            onClick: _cache[4] || (_cache[4] = function ($event) {
              return navigateTo(2);
            })
          }, [_cache[14] || (_cache[14] = _createTextVNode(" 点击前往- ", -1)), _cache[15] || (_cache[15] = _createElementVNode("span", {
            class: "tip"
          }, "活动广场", -1)), _cache[16] || (_cache[16] = _createTextVNode("-参与活动 ", -1)), _createElementVNode("img", {
            class: "right_icon",
            src: _unref(rightGray),
            alt: ""
          }, null, 8, _hoisted_9)])];
        }),
        key: "0"
      } : undefined]), 1032, ["empty"]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
        style: {
          "display": "flex",
          "align-items": "center"
        },
        onClick: _cache[6] || (_cache[6] = function () {
          return _unref(handleClick) && _unref(handleClick).apply(void 0, arguments);
        })
      }, [_cache[17] || (_cache[17] = _createElementVNode("span", null, "随便逛逛", -1)), _createElementVNode("img", {
        class: "right_icon",
        src: _unref(rightEnter),
        alt: ""
      }, null, 8, _hoisted_11)]), _cache[18] || (_cache[18] = _createElementVNode("p", null, "随便逛逛本校师生的个人主页", -1))])])]), _createElementVNode("div", _hoisted_12, [visListShow.value === 1 ? (_openBlock(), _createBlock(_component_t_input, {
        key: 0,
        modelValue: searchIdName.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
          return searchIdName.value = $event;
        }),
        placeholder: "请输入主页ID"
      }, {
        suffixIcon: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "icon-search",
            onClick: handleSearch
          }, [_createElementVNode("img", {
            src: require('@/assets/home/search.svg'),
            alt: ""
          }, null, 8, _hoisted_13)])];
        }),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), showMe.value && clickSerch.value ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([peopleList.value ? 'visitor-name' : 'visitor-base'])
      }, [peopleList.value && peopleList.value.isLocalUser === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("img", {
        src: peopleList.value.avatar || _unref(baseImg),
        alt: ""
      }, null, 8, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(peopleList.value.name), 1), _createElementVNode("span", _hoisted_18, _toDisplayString(peopleList.value.schoolName), 1)])])) : _createCommentVNode("", true), peopleList.value && peopleList.value.isLocalUser === 0 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "visitor_right",
        onClick: _cache[8] || (_cache[8] = function ($event) {
          return backHomeMe(peopleList.value);
        })
      }, [_cache[19] || (_cache[19] = _createTextVNode(" 进入主页 ", -1)), _createElementVNode("img", {
        src: _unref(rightEnter),
        alt: ""
      }, null, 8, _hoisted_19)])) : _createCommentVNode("", true), peopleList.value && peopleList.value.isLocalUser === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, "暂不支持查看学校外个人主页")) : _createCommentVNode("", true), !peopleList.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, "主页ID有误，请重新输入")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_22, [_cache[20] || (_cache[20] = _createElementVNode("span", {
        class: "lately_title"
      }, "最近访客", -1)), visList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visList.value, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createVNode(_component_t_popup, {
          placement: "left-bottom",
          "overlay-style": {
            padding: '16px'
          },
          onVisibleChange: function onVisibleChange($event) {
            return handleVisibleChange(index);
          }
        }, {
          content: _withCtx(function () {
            return [_createVNode(calling, {
              item: item.id,
              index: index,
              cardInfo: cardInfo.value,
              spaceInfo: __props.spaceInfo,
              onChangeToHome: changeToHome
            }, null, 8, ["item", "index", "cardInfo", "spaceInfo"])];
          }),
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("img", {
              src: item.avatar || _unref(baseImg),
              alt: ""
            }, null, 8, _hoisted_26), _createElementVNode("span", _hoisted_27, _toDisplayString(item.name), 1)]), _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(formatRelativeDate)(item.time)), 1)])];
          }),
          _: 2
        }, 1032, ["onVisibleChange"])]);
      }), 128))])) : _createCommentVNode("", true), visList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, "暂无访客")) : _createCommentVNode("", true)])])]);
    };
  }
};